import { Config } from "../../../api/config";
//API keys
export var JournalVoucherKeys = {
    Paging: "journalVoucherPaging",
    Create: "journalVoucherCreate",
    TechnicianList: "TechnicianList",
    ServiceAdvisorList: "ServiceAdvisorList",
    CustomerAssociationDetails: "CustomerAssociationDetails",
    WarehouseList: "WarehouseList",
    JournalDetailPaging: "JournalDetailPaging",
    JournalVoucherAccountList: "JournalVoucherAccountList",
    journalRowData: "journalRowData",
    JournalVoucherContactList: "JournalVoucherContactList",
    Get: "getJournalEntriesByHeader",
    GetJournalHeader: "GetJournalHeader",
    Update: "UpdateJournalHeader",
    uploadAttachment: "uploadAttachment",
    AttachmentSystemName: 'JournalVoucherAttachment',
    JournalVoucherPersonList: "JournalVoucherPersonList"
};
export var APIKeys = [JournalVoucherKeys.Create, JournalVoucherKeys.Get];
// API urls
export var getJournalVoucherDetails = "".concat(Config.baseURL, "spareIssuesGeneralDetails/Get");
export var getJournalVoucherPaging = "".concat(Config.baseURL, "JournalType/Paging");
export var getFilterTypeList = "".concat(Config.baseURL, "FilterType/List");
export var getSpareIssueSearchDetail = "".concat(Config.baseURL, "JobCard/GetSearchDetails");
export var getWarehouseList = "".concat(Config.baseURL, "Warehouse/ByTenant");
export var technicianListAPI = "".concat(Config.baseURL, "OrganizationEmployee/Technicians");
export var serviceAdvisorListAPI = "".concat(Config.baseURL, "IdentityOrganizationAccessRight/GetServiceAdvisor");
export var getCustomerByIdAPI = function (id) { return "".concat(Config.baseURL, "Customer/").concat(id, "/Get"); };
export var getPartDetailsAPI = "".concat(Config.baseURL, "JobCardDetail/PartsbyJobCard");
export var getLocationDetailsAPI = "".concat(Config.baseURL, "Inventory/GetAvailableQtyByWarehouse");
export var createJournalDetailUrl = "".concat(Config.baseURL, "JournalDetail/Create");
export var getJournalEntriesByHeaderUrl = "".concat(Config.baseURL, "JournalDetail/GetJournalEntriesByHeader");
export var getJournalHeaderUrl = function (id) { return "".concat(Config.baseURL, "JournalHeader/").concat(id, "/Get"); };
export var JournalDetailPagingUrl = "".concat(Config.baseURL, "JournalHeader/Paging");
export var JournalVoucherAccountPagingUrl = "".concat(Config.baseURL, "TenantChartOfAccount/GetAccountWithFilter");
export var JournalVoucherContactPagingUrl = "".concat(Config.baseURL, "TenantChartOfAccount/PersonList");
export var updateJournalHeaderUrl = function (id) { return "".concat(Config.baseURL, "JournalHeader/").concat(id, "/Update"); };
export var journalAttachmentCreateUrl = "".concat(Config.baseURL, "InventoryAttachment/Create");
export var journalVoucherAttachmentDeleteAPI = "".concat(Config.baseURL, "InventoryAttachment/DeleteInventoryAttachment");
//constants
export var visibleColumns = {
    DocumentNo: 'Document number',
    RequestedDateTime: 'Document date',
    JobCardNo: 'Job card No.',
    VinNo: 'VIN',
    RegistrationNo: 'Registration No.',
    CreatedByGivenName: 'Technician',
    CreatedOn: "CreatedOn",
    StatusName: 'Status'
};
export var filterTypeOptions = [{
        SourceId: "73988784-db91-4134-bbaf-77cea5f314c0",
        DisplayName: "Reg.No.",
        Value: "RegistrationNo"
    }, {
        SourceId: "73988784-db91-4134-bbaf-77cea5f314c0",
        DisplayName: "VIN.No.",
        Value: "VinNo"
    }, {
        SourceId: "5ea00d14-a3c4-4ccf-be85-2b04bbef57a1",
        DisplayName: "Job Card no.",
        Value: "JobCardNo"
    }];
export var JournalVoucherViewTypeOptions = [{
        id: 1,
        name: "My Journals"
    }, {
        id: 2,
        name: "All Journals"
    }];
export var accounts = [{
        label: 'Customer control account',
        id: '#01123223'
    }, {
        label: 'Purchase account',
        id: '#01123223'
    }, {
        label: 'Sale account',
        id: '#01123223'
    }, {
        label: 'Expense account',
        id: '#01123223'
    }, {
        label: 'Income account',
        id: '#01123223'
    }, {
        label: 'Inventory account',
        id: '#01123223'
    }, {
        label: 'Fixed assets account',
        id: '#01123223'
    }, {
        label: 'Depreciation account',
        id: '#01123223'
    }, {
        label: 'Liabilities account',
        id: '#01123223'
    }, {
        label: 'Equity account',
        id: '#01123223'
    }];
export var PopupType = {
    amountNotEqual: "amountNotEqual",
    validation: "validation",
    success: "success",
    error: "error",
    emptyArray: "emptyArray",
    Mandatory: "MandatoryJournalType",
    amountMissing: "amountMissing",
    contactMandatory: "contactMandatory",
    accountMissing: "accountMissing"
};
export var JournalDetailMandatoryFields = {
    'Account': 'Account'
};
export var validationModel = {
    CreditAmount: function (value) {
        var regex = /^\d+(\.\d{0,2})?$/;
        if (!(value === '' || regex.test(value))) {
            return "Enter Correct value";
        }
    },
    DebitAmount: function (value) {
        var regex = /^\d+(\.\d{0,2})?$/;
        if (!(value === '' || regex.test(value))) {
            return "Enter Correct value";
        }
    },
    PersonId: function (value, row) {
        if (!value && row.IsSubLedger) {
            return "Enter Correct value";
        }
    },
    Remarks: function (value) {
        if ((value === null || value === void 0 ? void 0 : value.length) > 500) {
            return "Value must be 500 or less";
        }
        return undefined;
    }
};
